'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'book-bookmark';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0bb';
var svgPathData = ['M16 56l0 360.8C26.2 406.4 40.3 400 56 400l352 0c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24l-56 0 0 200c0 3-1.6 5.7-4.2 7.1s-5.8 1.2-8.2-.4l-67.6-45-67.6 45c-2.5 1.6-5.6 1.8-8.2 .4S192 219 192 216l0-200-136 0C33.9 16 16 33.9 16 56z', 'M0 56C0 25.1 25.1 0 56 0L408 0c22.1 0 40 17.9 40 40l0 336c0 19.4-13.7 35.5-32 39.2l0 80.8 24 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L56 512c-30.9 0-56-25.1-56-56L0 56zM336 16l-128 0 0 185.1 59.6-39.7c2.7-1.8 6.2-1.8 8.9 0L336 201.1 336 16zM192 16L56 16C33.9 16 16 33.9 16 56l0 360.8C26.2 406.4 40.3 400 56 400l352 0c13.3 0 24-10.7 24-24l0-336c0-13.3-10.7-24-24-24l-56 0 0 200c0 3-1.6 5.7-4.2 7.1s-5.8 1.2-8.2-.4l-67.6-45-67.6 45c-2.5 1.6-5.6 1.8-8.2 .4S192 219 192 216l0-200zM56 416c-22.1 0-40 17.9-40 40s17.9 40 40 40l344 0 0-80-344 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;